import { getClassName } from '@perpay-web/utils/domUtils';

import styles from '@perpay-web/design/styles/inputs.scss';

export const InputPrefix = ({ prefix }) =>
    prefix ? (
        <span className={getClassName(styles.prefix)}>{prefix}</span>
    ) : null;
